module.exports = __webpack_public_path__ + "media/images/kyoto_zh-hans02-930a545aa4da6f145deb8a37cb09c196.jpg";